<div [ngClass]="{'top': atTop}" class="loading-indicator-wrapper">
  <app-loading-indicator></app-loading-indicator>
</div>
